// extracted by mini-css-extract-plugin
module.exports = {"labelWrapper":"InviteUserForm_labelWrapper_18lde","spinAround":"InviteUserForm_spinAround_1NmgM"};